const TUTORIAL_STORAGE_KEY = 'tutorial_displayed_first_time';
const FIRST_CASE_EDIT_TUTORIAL_KEY = 'tutorial_displayed_first_case_edit';
const DIVISIONS_TUTORIAL_KEY = 'tutorial_displayed_divisions';
const NOTIFICATIONS_TUTORIAL_KEY = 'tutorial_displayed_notifications';

export class TutorialService {
    /**
     * Check if the first-time tutorial has been displayed
     */
    static hasDisplayedFirstTimeTutorial(): boolean {
        return localStorage.getItem(TUTORIAL_STORAGE_KEY) === 'true';
    }

    /**
     * Mark the first-time tutorial as displayed
     */
    static markFirstTimeTutorialAsDisplayed(): void {
        localStorage.setItem(TUTORIAL_STORAGE_KEY, 'true');
    }

    /**
     * Reset the first-time tutorial (for testing or settings)
     */
    static resetFirstTimeTutorial(): void {
        localStorage.removeItem(TUTORIAL_STORAGE_KEY);
    }

    /**
     * Get the current tutorial display setting
     */
    static getTutorialDisplaySetting(): boolean {
        return !this.hasDisplayedFirstTimeTutorial();
    }

    /**
     * Set the tutorial display setting
     */
    static setTutorialDisplaySetting(showTutorials: boolean): void {
        if (showTutorials) {
            this.resetFirstTimeTutorial();
        } else {
            this.markFirstTimeTutorialAsDisplayed();
        }
    }

    /**
     * Check if the first case edit tutorial has been displayed
     */
    static hasDisplayedFirstCaseEditTutorial(): boolean {
        return localStorage.getItem(FIRST_CASE_EDIT_TUTORIAL_KEY) === 'true';
    }

    /**
     * Mark the first case edit tutorial as displayed
     */
    static markFirstCaseEditTutorialAsDisplayed(): void {
        localStorage.setItem(FIRST_CASE_EDIT_TUTORIAL_KEY, 'true');
    }

    /**
     * Reset the first case edit tutorial (for testing or settings)
     */
    static resetFirstCaseEditTutorial(): void {
        localStorage.removeItem(FIRST_CASE_EDIT_TUTORIAL_KEY);
    }

    /**
     * Check if the divisions tutorial has been displayed
     */
    static hasDisplayedDivisionsTutorial(): boolean {
        return localStorage.getItem(DIVISIONS_TUTORIAL_KEY) === 'true';
    }

    /**
     * Mark the divisions tutorial as displayed
     */
    static markDivisionsTutorialAsDisplayed(): void {
        localStorage.setItem(DIVISIONS_TUTORIAL_KEY, 'true');
    }

    /**
     * Reset the divisions tutorial (for testing or settings)
     */
    static resetDivisionsTutorial(): void {
        localStorage.removeItem(DIVISIONS_TUTORIAL_KEY);
    }

    static hasDisplayedNotificationsTutorial(): boolean {
        return localStorage.getItem(NOTIFICATIONS_TUTORIAL_KEY) === 'true';
    }

    static markNotificationsTutorialAsDisplayed(): void {
        localStorage.setItem(NOTIFICATIONS_TUTORIAL_KEY, 'true');
    }

    static resetNotificationsTutorial(): void {
        localStorage.removeItem(NOTIFICATIONS_TUTORIAL_KEY);
    }
}
